export const codeImages = {
  1: 'https://s3-ap-southeast-2.amazonaws.com/dashboard-uploads-2/num-1.jpg',
  2: 'https://s3-ap-southeast-2.amazonaws.com/dashboard-uploads-2/num-2.jpg',
  3: 'https://s3-ap-southeast-2.amazonaws.com/dashboard-uploads-2/num-3.jpg',
  4: 'https://s3-ap-southeast-2.amazonaws.com/dashboard-uploads-2/num-4.jpg',
  5: 'https://s3-ap-southeast-2.amazonaws.com/dashboard-uploads-2/num-5.jpg'
}